import { useQuery } from 'react-query'
import useAxios from './useAxios'

const useEvents = (typeEvent, nPage, numberPerPage) => {
	const { getEvents } = useAxios()
	const { isLoading, data: events } = useQuery(
		`evenements_${typeEvent}_${nPage}`,
		() => getEvents(typeEvent, nPage, numberPerPage),
		{
			refetchOnWindowFocus: true,
			staleTime: 0,
			cacheTime: 0,
		},
	)

	if (isLoading) return { isLoading }

	return {
		isLoading,
		events,
	}
}

export default useEvents
